import { SharedErrors } from 'web_core_library';
import { NO_ALERT_TYPE } from '../base/types';

export type FeedbackValue = null | number;

export interface IInternalFeedbackResult {
  feedback: FeedbackValue;
  negativeFollowup: FeedbackValue;
  comprehensionFollowup: FeedbackValue;
}

export interface IFullFeedbackResult extends IInternalFeedbackResult {
  exerciseId: string;
  startDifficulty: number;
  endDifficulty: number;
  goodRuns: number;
  badRuns: number;
  completionCount: number;
}

export class ExerciseError extends SharedErrors.BaseError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, ExerciseError.prototype);
    this.errorType = NO_ALERT_TYPE;
    this.feature = 'Exercise';
  }
}

export enum ENeededAdjustment {
  Lower = -1,
  Higher = 1,
}

export enum EExtraMode {
  None = 'None',
  Challenger = 'Challenger',
  Survival = 'Survival',
  Learning = 'Learning',
}

export interface IOpenExercisePayload {
  exerciseLink?: string;
  workoutIndex?: number;
}

export interface IInitDifficultyPayload {
  startDifficulty: number;
  reachedDifficulty: number;
}
